import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import LoaderButton from '../LoaderButton/LoaderButton';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const PasswordUpdatedModal = ({ t, }) => {
  const classes = useStyles();
  const [redirect, setRedirect] = useState(false);
  if (redirect) {
    window.location = '/dashboard/auth/sign-in';
  }
  return (
    <div className={classes.newPasswordMoal}>
      <h3> {t('password_updated')} </h3>
      <div className={classes.buttonContainer}>
        <LoaderButton label={t('ok')} onClick={() => setRedirect(true)} />
      </div>
    </div>
  );
};

PasswordUpdatedModal.propTypes = {
  t: PropTypes.func.isRequired,
};

const useStyles = createUseStyles({
  newPasswordMoal: {
    backgroundColor: 'white',
    width: '100%',
    maxWidth: '600px',
    borderRadius: '4px',
    padding: '2em 1em',
    '& h3': {
      color: ' #54515A',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});


export default withScopedTranslations('signIn')(PasswordUpdatedModal);

